import styled from 'styled-components';
import tokens from '@veneer/tokens';
import { Button } from '@veneer/core';

export const MastiffOfferButton = styled(Button)`
  position: relative;
  border-radius: 999px !important;
  padding: ${tokens.layout.size1} ${tokens.layout.size3} !important;
`;
